import { PayloadAction } from '@reduxjs/toolkit';

import { GalleryState } from 'editor/src/store/gallery/types';

const unselectImagesReducer = (state: GalleryState, action: PayloadAction<string[]>) => {
  state.selectedImagesIds = state.selectedImagesIds.filter((imageId) => !action.payload.includes(imageId));
};

export default unselectImagesReducer;
